import { HttpClient } from '@angular/common/http';
import { Injectable, Injector } from '@angular/core';
import { Store } from '@ngrx/store';
import * as _ from 'lodash';
import { getToggleEntities } from './../../../store/selectors/toggles-selectors';
import { PortalConfig } from './../portal-config';

@Injectable()
export class ToggleService {
  private publicConfig;
  public API_URL;
  public togglesFromStore;

  constructor(
    private http: HttpClient,
    private portalConfig: PortalConfig,
    private store: Store<any>,
    public injector: Injector,
  ) {
    this.publicConfig = portalConfig.publicConfig;
    this.API_URL = this.publicConfig.NV_API_ORIGIN + '/v1/toggle/';
  }

  getTogglesFromStore() {
    let toggles$ = this.store.select(getToggleEntities);
    toggles$.subscribe(data => (this.togglesFromStore = data));
  }

  getToggleState(toggleName: string) {
    if (!this.togglesFromStore) {
      this.getTogglesFromStore();
    }
    let toggleState = this.togglesFromStore[toggleName];

    // Can't inject rollbar in the constructor since it belongs to the old app and won't be available yet.
    // If it's a component, it can be done in OnInit
    const rollBar = this.injector.get('Rollbar');

    if (!toggleState) {
      // false or undefined
      if (_.isUndefined(toggleState)) {
        const errMsg = `Can\'t get the state for toggle ${toggleName}`;
        rollBar.error(new Error(errMsg));
      }
      return false;
    } else if (toggleState !== true) {
      // not a boolean; possibly an error object
      const errMsg = `Possible error in toggle state for toggle ${toggleName}. State: ${toggleState}`;
      rollBar.error(new Error(errMsg));
      return false;
    } else if (toggleState === true) {
      return true;
    } else {
      return false;
    }
  }

  getAllToggles() {
    const endPoint = this.API_URL;
    return this.http.get(endPoint);
  }

  getAllComputedToggles(configOptions) {
    const endPoint = this.API_URL + 'computed/' + JSON.stringify(configOptions);
    return this.http.get(endPoint);
  }
}
